import { Procon } from './procon';

export const BASE_SELECTOR: string = '[data-procon]';
export const START_SELECTOR: string = '[data-procon-start]';
export const STOP_SELECTOR: string = '[data-procon-stop]';
export const RESTART_SELECTOR: string = '[data-procon-restart]';
export const ACTIVATE_SELECTOR: string = '[data-procon-activate]';

export class ProconUI {
    constructor(private $base: JQuery) {
    }
    
    public onStartClick(callback: () => {}) {
        this.$base.find(START_SELECTOR).on('click', (t, args) => {
            callback();
        });
    }
    
    public onRestartClick(callback: () => {}) {
        this.$base.find(RESTART_SELECTOR).on('click', (t, args) => {
            callback();
        });
    }
    
    public onStopClick(callback: () => {}) {
        this.$base.find(STOP_SELECTOR).on('click', (t, args) => {
            callback();
        });
    }
}

export function proconStatus(state: number) {
    $('#procon_control > button, #procon_control > a:not([data-procon-activate])').hide();
    
    let states = [];
    states[0] = () => {
        $(ACTIVATE_SELECTOR).show();
        $('#server_status').html('<span style="color: #009ECC; font-weight: bold;">' + window.proconMessages['layer_setup'] + '</span>');
    
    };
    
    states[1] = () => {
        $('#server_status').html('<span style="color: #009ECC; font-weight: bold;">' + window.proconMessages['layer_install'] + '</span>');
    
    };
    states[2] = () => {
        $('#server_status').html('<span style="color: #009ECC; font-weight: bold;">' + window.proconMessages['layer_disabled'] + '</span>');
    
    };
    states[3] = () => {
        $(START_SELECTOR).show();
        $('#server_status').html('<span style="color: #009ECC; font-weight: bold;">' + window.proconMessages['layer_off'] + '</span>');
    
    };
    states[4] = () => {
        $('#server_status').html('<span style="color: #009ECC; font-weight: bold;">' + window.proconMessages['layer_stopped'] + '</span>');
    
    };
    states[5] = () => {
        $('#server_status').html('<span style="color: #009ECC; font-weight: bold;">' + window.proconMessages['layer_started'] + '</span>');
    
    };
    states[6] = () => {
        $(STOP_SELECTOR).show();
        $(RESTART_SELECTOR).show();
        $('#server_status').html('<span style="color: #009ECC; font-weight: bold;">' + window.proconMessages['layer_on'] + '</span>');
    
    };
    states[7] = () => {
        $('#server_status').html('<span style="color: #009ECC; font-weight: bold;">' + window.proconMessages['layer_update'] + '</span>');
    
    };
    states[99] = () => {
        $('#server_status').html('<span style="color: #009ECC; font-weight: bold;">' + window.proconMessages['layer_maintenance'] + '</span>');
    
    };
    states[8] = () => {
        $('#server_status').html('<span style="color: #009ECC; font-weight: bold;">' + window.proconMessages['stateDead'] + '</span>');
    
    };
    states[100] = () => {
        $('#server_status').html('<span style="color: #009ECC; font-weight: bold;">' + window.proconMessages['layer_unknown'] + '</span>');
        
    };
    
    states[state]();
}

export function createProconInstances(): ProconUI[] {
    const instances: ProconUI[] = [];
    $(BASE_SELECTOR).each((index, element) => {
        instances.push(new ProconUI($(element)));
    });
    
    if (instances.length) {
        Procon.updateStatus();
    }
    
    return instances;
}